import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import i18n from '../providers/i18n';

export type Language = 'ru' | 'en';

interface LanguageState {
  currentLanguage: Language;
  availableLanguages: Language[];
  setLanguage: (language: Language) => void;
  initializeLanguage: () => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => ({
      currentLanguage: 'ru',
      availableLanguages: ['ru', 'en'],
      
      setLanguage: (language: Language) => {
        set({ currentLanguage: language });
        i18n.changeLanguage(language);
      },
      
      initializeLanguage: () => {
        const { currentLanguage } = get();
        i18n.changeLanguage(currentLanguage);
      },
    }),
    {
      name: 'language-storage',
      partialize: (state) => ({ currentLanguage: state.currentLanguage }),
    }
  )
);